/**
 * convert string from hyphen case to title
 */
export const hyphenCase2Title = (hyphenCase) => {
  return (hyphenCase || '')
    .split('-')
    .map(t => t.charAt(0).toUpperCase() + t.slice(1))
    .join(' ');
};